import {connect} from 'react-redux';

import CoAppReminder from './CoAppReminder';
import InactivityAlertDialog from './InactivityAlertDialog';
import StipDialog from './StipDialog';
import VinReminder from './VinReminder';

const DialogContainer = props => {
    const {dialog} = props;
    const {id, data, callback} = dialog;

    switch (id) {
        case 'CoAppReminder':
            return <CoAppReminder callback={callback} />;
        case 'InactivityAlertDialog':
            return <InactivityAlertDialog data={data} callback={callback} />;
        case 'StipDialog':
            return <StipDialog data={data} callback={callback} />;
        case 'VinReminder':
            return <VinReminder data={data} callback={callback} />;
    }

    return null;
};

const mapStateToProps = (state) => {
    return {
        dialog: state.dialog
    };
};

export default connect(mapStateToProps)(DialogContainer);
